import EditEventApp from "./EditEventApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export { convertEventTypesToObjects } from "./editEventStore";

export default vueAppWithPinia(EditEventApp);
